export var SecurePassAutoSend;
(function (SecurePassAutoSend) {
    SecurePassAutoSend[SecurePassAutoSend["DoNotSend"] = 1] = "DoNotSend";
    SecurePassAutoSend[SecurePassAutoSend["Default"] = 2] = "Default";
    SecurePassAutoSend[SecurePassAutoSend["Send"] = 3] = "Send";
})(SecurePassAutoSend || (SecurePassAutoSend = {}));
export var ScanStatuses;
(function (ScanStatuses) {
    ScanStatuses[ScanStatuses["NotScanned"] = 1] = "NotScanned";
    ScanStatuses[ScanStatuses["Success"] = 2] = "Success";
    ScanStatuses[ScanStatuses["Fail"] = 3] = "Fail";
    ScanStatuses[ScanStatuses["ManualSuccess"] = 4] = "ManualSuccess";
    ScanStatuses[ScanStatuses["ManualFail"] = 5] = "ManualFail";
})(ScanStatuses || (ScanStatuses = {}));
export var SecurePassStatus;
(function (SecurePassStatus) {
    SecurePassStatus[SecurePassStatus["Pending"] = 1] = "Pending";
    SecurePassStatus[SecurePassStatus["Completed"] = 2] = "Completed";
    SecurePassStatus[SecurePassStatus["ManualCompleted"] = 3] = "ManualCompleted";
})(SecurePassStatus || (SecurePassStatus = {}));
export var SecurePassLogType;
(function (SecurePassLogType) {
    SecurePassLogType[SecurePassLogType["QRScanned"] = 1] = "QRScanned";
    SecurePassLogType[SecurePassLogType["VerificationAttempt"] = 2] = "VerificationAttempt";
    SecurePassLogType[SecurePassLogType["OutreachAttempt"] = 3] = "OutreachAttempt";
    SecurePassLogType[SecurePassLogType["QRCodeRetrieved"] = 4] = "QRCodeRetrieved";
    SecurePassLogType[SecurePassLogType["SecurePassSend"] = 5] = "SecurePassSend";
    SecurePassLogType[SecurePassLogType["VerificationOverride"] = 6] = "VerificationOverride";
    SecurePassLogType[SecurePassLogType["SecurePassCreateAttempt"] = 7] = "SecurePassCreateAttempt";
})(SecurePassLogType || (SecurePassLogType = {}));
export var SecurePassTagStatus;
(function (SecurePassTagStatus) {
    SecurePassTagStatus[SecurePassTagStatus["Disabled"] = 1] = "Disabled";
    SecurePassTagStatus[SecurePassTagStatus["MissingContact"] = 2] = "MissingContact";
    SecurePassTagStatus[SecurePassTagStatus["Enabled"] = 3] = "Enabled";
    SecurePassTagStatus[SecurePassTagStatus["FailedValidation"] = 4] = "FailedValidation";
    SecurePassTagStatus[SecurePassTagStatus["FailedOutreach"] = 5] = "FailedOutreach";
    SecurePassTagStatus[SecurePassTagStatus["Overridden"] = 6] = "Overridden";
})(SecurePassTagStatus || (SecurePassTagStatus = {}));
